import { fmtMoeda } from '@/lib/utils/formatters';
import { useApuracaoSN } from '@/contexts';

export function DASCard() {
  const { dados } = useApuracaoSN();

  return (
    <div className="rounded-xl bg-foreground text-background p-6 space-y-2">
      <p className="text-sm font-medium opacity-80">DAS a Recolher</p>
      <p className="text-4xl font-bold">{fmtMoeda(dados.dasARecolher)}</p>
      <p className="text-sm opacity-70">Vencimento: {dados.vencimento}</p>
    </div>
  );
}
